import { formatPhoneNumberIntl, type Value } from 'react-phone-number-input';

/**
 * Readable international form for stored E.164 numbers ("+4930000000" →
 * "+49 30 000000"), as the editor field shows it. Keep the raw value for
 * `tel:` links. Non-E.164 input is returned unchanged (DEV-539).
 */
export function formatPhoneForDisplay(value: string): string {
  const trimmed = value.trim();
  if (!trimmed.startsWith('+')) return value;
  return formatPhoneNumberIntl(trimmed as Value) || value;
}
